import TokenDisplay from '.'

export default class SimpleDisplay implements TokenDisplay {
  str: string

  constructor(str: string) {
    this.str = str
  }

  display(): string {
    return this.str
  }
}
